var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('br'),_c('div',{staticClass:"row justify-content-center text-center"},[_c('p',{staticClass:"lead"},[_vm._v("\n\t\t\t"+_vm._s(_vm.getGreeting())+", "+_vm._s(_vm.username)+"!\n\t\t")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center text-center"},[_c('img',{attrs:{"src":require("../../images/dashboard/logo_shayah.png"),"height":"50%","width":"50%"}})])
}]

export { render, staticRenderFns }